<template>
    <section class="infographic modules light blue">
        <circles-layout></circles-layout>
        <div class="blocks-wrapper">
            <div class="block" ref="block">
                <h3>Gevolgde modules OGT Academie</h3>
                <div class="solid-circles-wrapper">
                    <div>
                        <div class="solid-circle">
                            <p>{{ aantal }}</p>
                        </div>
                        <p>Aantal</p>
                    </div>
                    <div>
                        <progress-ring :theme="theme" :value="essentials"></progress-ring>
                        <p>Essentials</p>
                    </div>
                    <div>
                        <progress-ring :theme="theme" :value="eLearning"></progress-ring>
                        <p>E-learning</p>
                    </div>
                    <div>
                        <progress-ring :theme="theme" :value="webinars"></progress-ring>
                        <p>Webinars</p>
                    </div>
                    <div>
                        <progress-ring :theme="theme" :value="podcast"></progress-ring>
                        <p>Podcast</p>
                    </div>
                    <div>
                        <progress-ring :theme="theme" :value="scans"></progress-ring>
                        <p>Scans</p>
                    </div>
                    <div>
                        <progress-ring :theme="theme" :value="weLearning"></progress-ring>
                        <p>We-learning</p>
                    </div>
                </div>
            </div>

            <div class="block" ref="block2">
                <h3>Soorten modules</h3>
                <ul>
                    <li>Essentials: korte instructies (filmpjes) over concrete vaardigheden. (bv. ICT)</li>
                    <li>E-learning: online trainingen, individueel te volgen.</li>
                    <li>Webinars: 'live'-seminars waarbij volgers direct kunnen reageren.</li>
                    <li>Podcast: 'live' audio-uitzending, je wordt bijgepraat door een expert.</li>
                    <li>Scans: hoe staat het met jouw persoonlijke vaardigheden?</li>
                    <li>We-learning: online trainingen met meerdere personen te volgen.</li>
                </ul>
            </div>
            <!-- <div class="block" ref="block2">
                <h3>Meest gevolgde modules</h3>
                <div class="progressbar-wrapper">
                    <div>
                        <p>Eduarte: Introductie en kennismaking - 144</p>
                        <progress-bar :color="theme.stroke" :value="introductie" :max="144"></progress-bar>
                    </div>
                    <div>
                        <p>Eduarte: DLL: Maken en onderhouden Studiewijzer(s) - 97</p>
                        <progress-bar :color="theme.stroke" :value="dll" :max="144"></progress-bar>
                    </div>
                    <div>
                        <p>Eduarte: Aan- en Afwezigheid registreren, bewerken en inzien - 94</p>
                        <progress-bar :color="theme.stroke" :value="afwezigheid" :max="144"></progress-bar>
                    </div>
                    <div>
                        <p>Microsoft Teams voor scholen - 35</p>
                        <progress-bar :color="theme.stroke" :value="teamsVoorScholen" :max="144"></progress-bar>
                    </div>
                    <div>
                        <p>Videobellen met Microsoft Teams - 31</p>
                        <progress-bar :color="theme.stroke" :value="bellenMetTeams" :max="144"></progress-bar>
                    </div>
                </div>
            </div>
            <div class="block">
                <h3>Gebruikers</h3>
                <div class="solid-circles-wrapper">
                    <div>
                        <div class="solid-circle">
                            <p>{{ numActiveUsers }}</p>
                        </div>
                        <p>Aantal</p>
                    </div>
                    <div>
                        <div class="solid-circle">
                            <p>{{ numCertificates }}</p>
                        </div>
                        <p>Aantal</p>
                    </div>
                </div>
            </div> -->
        </div>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    import ProgressRing from '@/app/components/progressRing';
    // import ProgressBar from '@/app/components/progressBar';

    import { gsap } from '@/vendor';

    export default {
        name: 'InfoModules',

        meta: {
            title: 'InfoModules',
            color: '#36B1CA'
        },

        components: {
            'circles-layout': Circles,
            'progress-ring': ProgressRing
            // 'progress-bar': ProgressBar
        },

        data()
        {
            return {
                aantal: 1258,
                essentials: 45,
                eLearning: 36,
                webinars: 14,
                podcast: 2,
                scans: 2,
                weLearning: 1,

                introductie: 114,
                dll: 97,
                afwezigheid: 94,
                teamsVoorScholen: 35,
                bellenMetTeams: 31,

                numActiveUsers: 368,
                numCertificates: 94,

                theme: {
                    text: '#000000',
                    stroke: '#36B1CA',
                    track: '#eaf7fa'
                }
            };
        },
        mounted()
        {
            this.tl = gsap.timeline({ paused: true });

            this.tl.from( this, { aantal: 0, duration: 1, roundProps: 'aantal' }, 0.3 );
            this.tl.from( this, { essentials: 0, duration: 1, roundProps: 'essentials' }, 0.4 );
            this.tl.from( this, { eLearning: 0, duration: 1, roundProps: 'eLearning' }, 0.5 );
            this.tl.from( this, { webinars: 0, duration: 1, roundProps: 'webinars' }, 0.6 );
            this.tl.from( this, { podcast: 0, duration: 1, roundProps: 'podcast' }, 0.7 );
            this.tl.from( this, { scans: 0, duration: 1, roundProps: 'scans' }, 0.8 );
            this.tl.from( this, { weLearning: 0, duration: 1, roundProps: 'weLearning' }, 0.9 );

            this.tl.from( this, { introductie: 0, duration: 1, roundProps: 'introductie' }, 0.3 );
            this.tl.from( this, { dll: 0, duration: 1, roundProps: 'dll' }, 0.4 );
            this.tl.from( this, { afwezigheid: 0, duration: 1, roundProps: 'afwezigheid' }, 0.5 );
            this.tl.from( this, { teamsVoorScholen: 0, duration: 1, roundProps: 'teamsVoorScholen' }, 0.6 );
            this.tl.from( this, { bellenMetTeams: 0, duration: 1, roundProps: 'bellenMetTeams' }, 0.7 );

            this.tl.from( this, { numActiveUsers: 0, duration: 1, roundProps: 'numActiveUsers' }, 0.3 );
            this.tl.from( this, { numCertificates: 0, duration: 1, roundProps: 'numCertificates' }, 0.4 );
        },

        methods: {
            focus()
            {
                this.tl.play();
            },
            blur()
            {
                this.tl.reverse();
            }
        }
    };
</script>
